// extracted by mini-css-extract-plugin
export default {"legalCopy":"LegalCopy-module_legalCopy_vSH95ftznR"};